import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import ButtonSp from '../../components/ButtonSp';

import InputTextSp from '../../components/InputTextSp';
import LabelSp from '../../components/LabelSp';
import { showMessage } from '../../components/MessageDialog';

import CampanhaService from '../../services/CampanhaService';

import { errorHandle, validateFields } from '../../util/functions';
import { CampanhaModel } from '../../util/Models';
import { StateScreen } from '../constants';
import DropdownSp from '../../components/DropdownSp';

function CampanhaCrud(props) {
  CampanhaCrud.propTypes = {
    stateScreen: PropTypes.string.isRequired,
    idSelected: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  CampanhaCrud.defaultProps = {
    messageConfirmation: 'Confirma os dados',
    showConfirmation: false,
  };

  const { stateScreen, idSelected, onClose } = props;

  // states
  const [campanha, setCampanha] = useState(new CampanhaModel());

  const [errorLoadRecord, setErrorLoadRecord] = useState(false);

  // useCallbacks

  const loadRecord = useCallback(async _id => {
    try {
      const retorno = await CampanhaService.findById(_id);

      setCampanha(retorno);

      setErrorLoadRecord(false);
    } catch (err) {
      setErrorLoadRecord(true);
      errorHandle(err);
    }
  }, []);

  // funcoes
  function viewMode() {
    return stateScreen === StateScreen.stView || errorLoadRecord;
  }

  function handleBack() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      showMessage('Confirmação', 'Abandonar mudanças?', idx => {
        if (idx === 1) {
          onClose();
        }
      });
    }
  }

  function handleSave() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      salvarRecord();
    }
  }

  async function salvarRecord() {
    try {
      let retorno;
      if (stateScreen === StateScreen.stInsert) {
        retorno = await CampanhaService.insert(campanha);
      } else {
        retorno = await CampanhaService.update(campanha);
      }
      toast.success('Registro salvo com sucesso.');
      onClose(retorno);
    } catch (err) {
      errorHandle(err);
    }
  }

  // useEffects
  useEffect(() => {
    if (stateScreen === StateScreen.stUpdate || stateScreen === StateScreen.stView) {
      loadRecord(idSelected);
    } else if (stateScreen === StateScreen.stInsert) {
      const novo = new CampanhaModel();

      setCampanha(novo);
    }
  }, [loadRecord, idSelected, stateScreen]);

  // render principal
  return (
    <>
      <>
        <div className="p-col-12 p-sm-5 p-lg-5 p-fluid">
          <LabelSp>Nome</LabelSp>
          <InputTextSp
            autoFocus
            value={campanha.nome}
            maxLength={100}
            required
            disabled={viewMode()}
            onChange={e => {
              setCampanha({ ...campanha, nome: e.target.value });
            }}
          />
        </div>
        <div className="p-col-12 p-sm-5 p-lg-5 p-fluid">
          <LabelSp>Descrição</LabelSp>
          <InputTextSp
            value={campanha.descricao}
            maxLength={100}
            disabled={viewMode()}
            onChange={e => {
              setCampanha({ ...campanha, descricao: e.target.value });
            }}
          />
        </div>

        <div className="p-col-4 p-md-2 p-lg-2 p-fluid">
          <LabelSp>Inativo?</LabelSp>
          <DropdownSp
            disabled={viewMode()}
            options={[
              { label: 'Sim', value: true },
              { label: 'Não', value: false },
            ]}
            value={campanha.inativo}
            onChange={e => {
              setCampanha({
                ...campanha,
                inativo: e.target.value,
                dataFimContrato: !e.target.value ? null : campanha.dataFimContrato,
              });
            }}
          />
        </div>

        <div className="p-col-12 p-lg-12" style={{ textAlign: 'start' }}>
          {!viewMode() ? (
            <ButtonSp
              className="p-button-success"
              icon="pi pi-save"
              label="Salvar"
              keyAccess="S"
              disabled={!validateFields(campanha, ['nome'])}
              showConfirmation
              onClick={handleSave}
            />
          ) : null}
          <ButtonSp
            className="p-button-secondary"
            label="Voltar"
            icon="pi pi-chevron-circle-left"
            keyAccess="V"
            onClick={handleBack}
          />
        </div>
      </>
    </>
  );
}

export default CampanhaCrud;
